<template>
<div class="chapter">
<div class="inner_page">
<p class="C4382"><strong><span id="page_11"></span><span class="small">PART</span> 1</strong></p>
<p class="P117"><strong>Assessing and Predicting Climate Change Impacts on Wildlife</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Part_1_A.vue?307a4a6f